import L from 'leaflet'
import { isMobile } from '@map-sdk/hooks'
import { ShipxyOptions } from '@map-sdk/sdk/config'
import { CanvasShipUtils } from '@map-sdk/sdk/utils/CanvasShipUtils'
import { GetAllTyphoon } from '@map-sdk/sdk/plugins/weather/Typhoon/data'
import { typhoonLegendImpl } from '@map-sdk/sdk/plugins/weather/Typhoon/TyphoonLegendImpl'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'
import type { TyphoonLegendControl } from '@map-sdk/sdk/plugins/weather/Typhoon/TyphoonLegendImpl'

interface TyphonInfoListOptions {
  weatherService?: any
  closeCallback?: () => void
  noIngCallback?: () => void
  cbLoadData?: (item: any, done: any) => void
  showWarningLine?: boolean
  showWinList: boolean
  showLegendList?: boolean
  showNameLess?: boolean
  autoLocation?: boolean
  weather?: {
    typhoonListUrl: string
    ak: string
  }
}
// 更精确的类型取决于layer的真实内容
const layerTyPhon: Record<string, any> = {}
/**
 * 台风信息列表
 */
class TyphonInfoList {
  private options: TyphonInfoListOptions
  private noteCheck: Record<string, any>
  private isShow: boolean
  private _map: MyMap
  private warningLineLayer?: L.LayerGroup
  private _legend!: TyphoonLegendControl
  constructor(map: MyMap, options?: TyphonInfoListOptions) {
    this.options = {
      showWarningLine: true,
      showWinList: true,
      showLegendList: false,
      showNameLess: true,
      autoLocation: true,
    }
    L.Util.extend(this.options, options ?? {})
    this.noteCheck = {}
    this.isShow = true
    this._map = map
    this.setListWin1Show(this.options.showWinList)
  }
  private _init() {
    this._drawWarningLine()
    // const typhoonListUrl = ShipxyOptions.weather.typhoonListUrl.replace(
    //   '{k}',
    //   (this._map.options as any).ak
    // )

    // console.log('TODO: _init 未实现 获取全部台风', typhoonListUrl)
    // const loadPromise = $.getJSON(typhoonListUrl).then((GetAllTyphoon) => {
    if (GetAllTyphoon && GetAllTyphoon.status === 0 && GetAllTyphoon.data) {
      const sortCallback = (keyCode: string, isString = false) =>
        isString
          ? (a: any, b: any) =>
              Number(a[keyCode]) > Number(b[keyCode]) ? -1 : 1
          : (a: any, b: any) => (a[keyCode] > b[keyCode] ? -1 : 1)

      const resultObj: { [key: string]: any[] } = {}

      GetAllTyphoon.data.forEach(
        (item: { currentyear: any; enname: string }) => {
          const currentyear = `year_${item.currentyear}`
          resultObj[currentyear] = resultObj[currentyear] || []
          this.noteCheck[currentyear] = []
          if (this.options.showNameLess || item.enname !== 'NAMELESS') {
            resultObj[currentyear].push(item)
          }
        }
      )

      for (const key in resultObj) {
        const list = resultObj[key]
        if (list && list.length > 0) {
          resultObj[key] = list.sort(sortCallback('chncode', true))
          resultObj[key] = list.sort(sortCallback('datamark'))
        }
      }
      // this._defaultTest(resultObj)
    } else {
      console.error(GetAllTyphoon)
    }
  }

  setListWin1Show(lineList: boolean) {
    const typhoonListWin1Element = document.querySelector(
      '#typhoonListWin1'
    ) as HTMLDivElement
    if (typhoonListWin1Element) {
      if (lineList) {
        typhoonListWin1Element.style.display = 'block' // 显示
      } else {
        typhoonListWin1Element.style.display = 'none' // 隐藏
      }
    }
  }

  /**
   * 绘制警戒线
   */
  private _drawWarningLine() {
    if (this.options.showWarningLine) {
      this.warningLineLayer = L.layerGroup()
      const layerGroup = L.layerGroup()

      const polyline1 = [
        L.latLng(0, 105),
        L.latLng(4.5, 113),
        L.latLng(11, 119),
        L.latLng(18, 119),
        L.latLng(22, 127),
        L.latLng(34, 127),
      ]
      const polyline2 = [
        L.latLng(0, 105),
        L.latLng(0, 120),
        L.latLng(15, 132),
        L.latLng(34, 132),
      ]

      layerGroup.addLayer(
        L.polyline(polyline1, {
          color: '#BE621F',
          weight: 2,
        })
      )
      layerGroup.addLayer(
        L.polyline(polyline2, {
          color: '#BE621F',
          weight: 2,
          dashArray: [5, 5],
        })
      )

      layerGroup.addLayer(
        L.marker(L.latLng(28, 127), {
          icon: L.icon({
            iconUrl: ShipxyOptions.weather.hour24,
            iconSize: [15, 89],
            iconAnchor: [22, 94],
            popupAnchor: [-3, -76],
            shadowSize: [68, 95],
            shadowAnchor: [22, 94],
          }),
        })
      )

      layerGroup.addLayer(
        L.marker(L.latLng(25, 132), {
          icon: L.icon({
            iconUrl: ShipxyOptions.weather.hour48,
            iconSize: [15, 89],
            iconAnchor: [22, 94],
            popupAnchor: [-3, -76],
            shadowSize: [68, 95],
            shadowAnchor: [22, 94],
          }),
        })
      )

      this.warningLineLayer.addLayer(layerGroup)
      this._map.addLayer(this.warningLineLayer)

      // 绘制台风图例
      if (!isMobile) {
        if (!this._legend) {
          this._legend = typhoonLegendImpl()
          this._legend.addTo(this._map)
        }
        this._legend.show(this.options.showLegendList)
      }
    }
  }

  public selectItem(item: any, isChecked = false) {
    if (isChecked) {
      CanvasShipUtils.openLoadingPopup(50, () => {
        this._getTyphoonInfoByKey(item, (GetAllTyphoon, item, isParse) => {
          if (isParse) {
            GetAllTyphoon = this.options.weatherService._parseRawTyphoon(
              GetAllTyphoon,
              this.options
            )
          }
          layerTyPhon[`layer_${item.id}`] =
            this.options.weatherService.showTyphoon(
              GetAllTyphoon,
              item,
              this.options
            )
          CanvasShipUtils.closeLoadingPopup()
        })
      })
    } else {
      this.options.weatherService.hideTyphoon(layerTyPhon[`layer_${item.id}`])
    }
  }

  private _getTyphoonInfoByKey(
    item: any,
    cb: (GetAllTyphoon: any, item: any, isParse: boolean) => void
  ) {
    // const typhoonInfoUrl = ShipxyOptions.weather.typhoonInfoUrl

    if (!this.options.cbLoadData) {
      console.error('请配置 cbLoadData 回调方法')
      return
    }
    this.options.cbLoadData(item, (data: any) => {
      console.log(data, 'data')
      cb(data, item, false)
    })
  }

  show() {
    this.isShow = true
    this._show()
  }

  private _show() {
    this._remove()
    if (this.isShow) {
      this._init()
    }
  }

  remove() {
    this.isShow = false
    this._remove()
  }
  private mousewheelHandler(event: Event) {
    event.stopPropagation()
  }
  private _remove() {
    const typhoonListWin1 = document.querySelector('#typhoonListWin1')
    if (typhoonListWin1) {
      const typhoonListElement = document.querySelector('#typhoonList')
      if (typhoonListElement) {
        typhoonListElement.removeEventListener(
          'mousewheel',
          this.mousewheelHandler
        )
        typhoonListElement.removeEventListener(
          'DOMMouseScroll',
          this.mousewheelHandler
        )
      }
      this.options.weatherService.hideTyphoon('all')
      typhoonListWin1.remove()
    }

    if (this.warningLineLayer) {
      this.warningLineLayer.clearLayers()
    }
    if (this._legend) {
      this._legend.show(false)
    }
  }
}

const typhoonInfoList = (
  map: MyMap,
  option: TyphonInfoListOptions | undefined
) => new TyphonInfoList(map, option)

export { TyphonInfoList, typhoonInfoList }
